<script>
	import { onMount } from 'svelte';
	import { get, writable } from 'svelte/store';
	import Ripple from './Ripple.svelte';
	import { storeSettings } from '../../store/StoreSettings';

	const primaryColor = get(storeSettings).primaryColor;

	export let rippleBlur = 2,
		speed = 500,
		color = '#fff',
		fontSize = '1.1rem',
		bgColor = primaryColor,
		bgHover = bgColor,
		bgActive = bgColor,
		rippleColor = '#000000',
		round = '0.5rem',
		height = 48,
		width = 250,
		sizeIn = 20,
		opacityIn = 0.2,
		shadow = 'none',
		shadowHover = 'none',
		shadowActive = 'none',
		loading = false;

	let shadows = {
			none: 'none',
			1: '0 0 0 1px rgba(0, 0, 0, 0.05)',
			2: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
			3: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
			4: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
			5: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
			6: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
			7: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
		},
		mouseX,
		mouseY;

	function handleRipple() {
		const ripples = writable([]);

		return {
			subscribe: ripples.subscribe,

			add: (item) => {
				ripples.update((items) => {
					return [...items, item];
				});
			},
			clear: () => {
				ripples.update((items) => {
					return [];
				});
			}
		};
	}

	export const ripples = handleRipple();

	let rect,
		rippleBtn,
		w,
		h,
		x,
		y,
		offsetX,
		offsetY,
		deltaX,
		deltaY,
		locationY,
		locationX,
		scale_ratio,
		timer;

	let coords = { x: 50, y: 50 };

	$: (offsetX = Math.abs(w / 2 - coords.x)),
		(offsetY = Math.abs(h / 2 - coords.y)),
		(deltaX = w / 2 + offsetX),
		(deltaY = h / 2 + offsetY),
		(scale_ratio = Math.sqrt(Math.pow(deltaX, 2.2) + Math.pow(deltaY, 2.2)));

	const debounce = () => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			ripples.clear();
		}, speed + speed * 2);
	};

	let touch;

	function handleClick(e, type) {
		if (type == 'touch') {
			touch = true;
			ripples.add({ x: e.pageX - locationX, y: e.pageY - locationY, size: scale_ratio });
		} else {
			if (!touch) {
				ripples.add({ x: e.clientX - locationX, y: e.clientY - locationY, size: scale_ratio });
			}
			touch = false;
		}
		debounce();
	}

	onMount(() => {
		w = rippleBtn.offsetWidth;
		h = rippleBtn.offsetHeight;
		rect = rippleBtn.getBoundingClientRect();
		locationY = rect.y;
		locationX = rect.x;
	});
</script>

<button
	class="Huabs56"
	on:click
	style="--color: {color};--font-size: {fontSize};--bg-color: {bgColor};--bg-hover: {bgHover};--bg-active: {bgActive};--radius: {round};--ripple: {rippleColor};--height: {height}px;--width: {width}px;--shadow: {shadows[
		shadow
	]};--shadow-h: {shadows[shadowHover]};--shadow-a: {shadows[shadowActive]}"
	bind:this={rippleBtn}
	on:touchstart={(e) => handleClick(e.touches[0], 'touch')}
	on:mousedown={(e) => handleClick(e, 'click')}
>
	<span>
		<slot />
		{#if loading}
			<svg
				aria-hidden="true"
				class="ml-2 w-5 h-5 text-gray-600 animate-spin dark:text-gray-600 fill-white"
				viewBox="0 0 100 101"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
					fill="currentColor"
				/>
				<path
					d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
					fill="currentFill"
				/>
			</svg>
		{/if}
	</span>
	<svg class="svg-ripple">
		{#each $ripples as ripple, index}
			<Ripple
				x={ripple.x}
				y={ripple.y}
				size={ripple.size}
				{speed}
				{sizeIn}
				{opacityIn}
				{rippleBlur}
			/>
		{/each}
	</svg>
</button>

<style>
	.Huabs56 {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border: none;
		font-weight: 500;
		color: var(--color);
		font-size: var(--font-size);
		height: var(--height);
		width: var(--width);
		max-width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		border-radius: var(--radius);
		cursor: pointer;
		-webkit-transition: 200ms all ease-out;
		transition: 200ms all ease-out;
		background-color: var(--bg-color);
		overflow: hidden;
		font-family: Roboto, sans-serif;
		box-shadow: var(--shadow);
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		-webkit-tap-highlight-color: transparent;
	}

	button.Huabs56:hover,
	button.Huabs56:focus {
		outline: none;
		background-color: var(--bg-hover);
		box-shadow: var(--shadow-h);
	}
	button.Huabs56:active {
		outline: none;
		background-color: var(--bg-active);
		box-shadow: var(--shadow-a);
	}
	.Huabs56 span {
		position: relative;
		height: 100%;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0;
		padding: 0;
		z-index: 1;
	}
	.Huabs56 svg.svg-ripple {
		height: 100%;
		pointer-events: none;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;
		width: 100%;
	}
</style>
